enum PrescriptionEyeConditionType {
    LOW_MYOPE = 'low_myope',
    HIGH_MYOPE = 'high_myope',
    EMMETROPIC = 'emmetropic',
    LOW_HYPEROPE = 'low_hyperope',
    HIGH_HYPEROPE = 'high_hyperope',
}

export default PrescriptionEyeConditionType;